import { render } from "./short-list.vue?vue&type=template&id=d38a31f8"
import script from "./short-list.vue?vue&type=script&lang=js"
export * from "./short-list.vue?vue&type=script&lang=js"

import "./short-list.vue?vue&type=style&index=0&id=d38a31f8&lang=css"

import exportComponent from "D:\\MY PROJECTS\\Vue 3 Project\\MarriageBeauroAdmin\\marriage_beauro_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__